// extracted by mini-css-extract-plugin
export default {"container":"ChatCode_container__fCST6","form":"ChatCode_form__CrIoW","betaWarning":"ChatCode_betaWarning__tt5tV"};